import script from "./ElectronicInvoiceInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./ElectronicInvoiceInfo.vue?vue&type=script&setup=true&lang=js"

import "./ElectronicInvoiceInfo.vue?vue&type=style&index=0&id=f2708ff8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.23_vue@3.5.23_webpack@5.102.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2708ff8"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/.pnpm/vue-cli-plugin-quasar@5.0.2/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
